import { h, ComponentChildren, JSX } from 'preact'

interface Props {
  isValid?: boolean,
  children: ComponentChildren
}

const Pill = ({ isValid = true, children }: Props): JSX.Element =>
  <div class={`preact-pill ${!isValid ? 'invalid' : ''}`}>{children}</div>

export default Pill
